import React from 'react'
import Label from './Input/Label'

export const IO = props => {
  const { customComponent, config, editable, index } = props || {}
  const { Component } = props.ctx ?? {}
  return (
    <>
      {
        editable &&
        <Label {...props} />
      }
      <div className={`w-100 h-100 d-flex align-center custom-component-wrapper`}>
        {
          Component && customComponent && customComponent.id
            ? <Component component={customComponent} item={props.record} index={index} />
            : <span />
        }
        <style jsx>{`
        .custom-component-wrapper {
          justify-content: ${config && config.align === `center` ? `center` : `flex-${(config && config.align) || `start`}`};
        }
      `}</style>
      </div>
    </>
  )
}

export const Input = IO
export const Output = IO
